import type { ReactNode } from 'react';

import { Button } from '../../../components/ui';
import { useT } from '../../../i18n';

/** Một dòng thiết lập: nhãn bên trái, điều khiển và nút khôi phục bên phải. */
export function DongThietLap({
  nhan,
  mo,
  laMacDinh,
  onKhoiPhuc,
  children,
}: {
  nhan: string;
  mo?: string;
  /** Bỏ trống thì dòng không có nút khôi phục. */
  laMacDinh?: boolean;
  onKhoiPhuc?: () => void;
  children: ReactNode;
}) {
  const { t } = useT();
  return (
    <div className="grid gap-x-8 gap-y-3 border-b border-default py-5 first:pt-0 last:border-0 last:pb-0 md:grid-cols-[11rem_minmax(0,1fr)]">
      <div className="min-w-0">
        <h3 className="text-sm font-medium text-content-primary">{nhan}</h3>
        {mo && <p className="mt-1 text-xs leading-relaxed text-content-muted">{mo}</p>}
      </div>
      <div className="min-w-0 space-y-3">
        {children}
        {onKhoiPhuc && (
          <Button variant="outline" size="sm" disabled={laMacDinh} onClick={onKhoiPhuc}>
            {t('tuyChinh.khoiPhucMacDinh')}
          </Button>
        )}
      </div>
    </div>
  );
}
